module.exports = __webpack_public_path__ + "img/Cart.33f848b7.svg";